import { ResolveResource } from './utils'
import Factory from './utils/Factory'
import graphql from '@/api/graphql'
import Mutations from '@/api/graphql/mutations'
const resource = ResolveResource(__filename)

import fetch from '@/fetch'

export default new Factory(resource, {
  decline(payload) {
    return graphql.request(Mutations.ContractDecline, payload)
  },
  resend(payload = {}) {
    let { id } = payload
    return fetch(`/api/contract/${id}/resend`, { method: 'POST' })
  },
})
